export { default as go } from './go.svg'
export { default as jogaLogo } from './jogaLogo.svg'
export { default as jogaOnlineLogo } from './jogaOnlineLogo.svg'
export { default as lock } from './lock.svg'
export { default as playButton } from './playButton.svg'
export { default as plnevedomiLogo } from './plnevedomiLogo.svg'
export { default as subscribeBoxA } from './subscribeBoxA.svg'
export { default as subscribeBoxB } from './subscribeBoxB.svg'
export { default as subscribeBoxC } from './subscribeBoxC.svg'
